import { CircularProgress, Link } from '@mui/material'
import { getSummarySheet } from 'controllers/conformity/index'
import { ConformityListContext } from 'enums/conformity'
import React, { useState } from 'react'

interface DownloadSummarySheetLinkProps {
  context: ConformityListContext
  disabled?: boolean
  entryNumber?: string
  inboundTripGuid: string
}

export default function DownloadSummarySheetLink({ context, disabled, entryNumber, inboundTripGuid }: DownloadSummarySheetLinkProps) {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  return (
    <Link
      onClick={() => {
        if (disabled || isSubmitting) return

        let fileName = 'Conformity Summary Sheet'
        if (entryNumber) fileName += ' ' + entryNumber
        fileName += '.xlsx'

        setIsSubmitting(true)
        getSummarySheet(inboundTripGuid, fileName, context).finally(() => setIsSubmitting(false))
      }}
      sx={{ cursor: disabled ? 'not-allowed' : isSubmitting ? 'wait' : 'pointer' }}
    >
      Download Summary Sheet {isSubmitting && <CircularProgress size={16} sx={{ ml: 1 }} />}
    </Link>
  )
}
